import { useEffect } from 'react';
import type { Canvas } from 'fabric';
import { applyModelToFabric } from '../converters/model-to-fabric';
import type { PieceModel } from '../types';
import { useMedia } from '../../media';
import { applyGuard } from './apply-guard';

/**
 * Draws the model onto the canvas whenever it changes.
 * Flags the guard while writing so the reverse sync ignores the echo.
 */
export const useModelToFabric = (canvas: Canvas | null, model: PieceModel): void => {
  const { registerVideo, trackMediaLoad } = useMedia();

  useEffect(() => {
    if (!canvas) return;
    applyGuard.begin();
    try {
      applyModelToFabric(canvas, model, registerVideo, trackMediaLoad);
    } finally {
      applyGuard.end();
    }
  }, [canvas, model, registerVideo, trackMediaLoad]);
};
